import {t} from "@lingui/core/macro";
import {StyleSheet} from "aphrodite";
import React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {Popover, PopoverContentCore} from "@khanacademy/wonder-blocks-popover";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {Body, HeadingSmall} from "@khanacademy/wonder-blocks-typography";
import {staticUrl} from "@khan/urls";

type Props = {
    dismiss?: () => void;
};

const AskKhanmigo = ({dismiss}: Props): React.ReactElement => {
    const [opened, setOpened] = React.useState(true);

    return (
        <Popover
            id="editor-tutorial"
            content={
                <PopoverContentCore
                    closeButtonVisible={true}
                    style={styles.popover}
                >
                    <View style={styles.tutorialText}>
                        <HeadingSmall
                            id="editor-tutorial-title"
                            style={styles.tutorialHeading}
                        >
                            {t`Ask Khanmigo!`}
                        </HeadingSmall>
                        <Body id="editor-tutorial-content">
                            {t`Select text, then ask Khanmigo for changes!`}
                        </Body>
                    </View>
                    <img
                        src={staticUrl(
                            "/images/coach-dashboard/editor-tutorial.gif",
                        )}
                        alt=""
                        width={288}
                        height={165}
                    />
                </PopoverContentCore>
            }
            placement="left"
            opened={opened}
            onClose={() => {
                setOpened(false);
                if (dismiss) {
                    dismiss();
                }
            }}
        >
            <View style={styles.popoverAnchor} />
        </Popover>
    );
};

const styles = StyleSheet.create({
    popover: {
        padding: 0,
    },
    tutorialText: {
        margin: spacing.large_24,
    },
    tutorialHeading: {
        marginBottom: spacing.xSmall_8,
    },
    popoverAnchor: {
        position: "sticky",
        top: 160,
        marginLeft: 30,
        // @ts-expect-error - TS2322 - not assignable to type 'CSSProperties'.
        "@media screen and (max-width: 1400px)": {
            marginLeft: 300,
        },
    },
});

export default AskKhanmigo;
